const ALLOWED_LANGUAGES = ["ar", "en"];

/**
 * base64url, as the sender emits it: `-`/`_` for `+`/`/` and no padding, which `atob` may
 * reject. Decoded through TextDecoder so a non-ASCII byte survives — `atob` yields one
 * character per byte, not per code point.
 */
const decodeBase64Url = (encoded) => {
  const base64 = encoded.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64.padEnd(
    base64.length + ((4 - (base64.length % 4)) % 4),
    "="
  );
  const bytes = Uint8Array.from(atob(padded), (character) =>
    character.charCodeAt(0)
  );

  return new TextDecoder().decode(bytes);
};

/**
 * Decode the support-session payload the central dashboard puts in the URL fragment.
 *
 * Returns null for anything that is not a payload carrying a token, so a hand-typed or
 * truncated link fails as "bad link" rather than half-writing a session.
 */
export const readSupportAccessPayload = (hash) => {
  const encoded = (hash || "").replace(/^#/, "");

  if (!encoded) return null;

  try {
    const payload = JSON.parse(decodeBase64Url(encoded));

    if (!payload || typeof payload.token !== "string" || !payload.token) {
      return null;
    }

    return {
      token: payload.token,
      central_access_token:
        typeof payload.central_access_token === "string"
          ? payload.central_access_token
          : null,
      // Only the two locales this app has routes for — the value is written straight to
      // `default-lg` and interpolated into the landing path.
      language: ALLOWED_LANGUAGES.includes(payload.language)
        ? payload.language
        : null,
    };
  } catch {
    return null;
  }
};
